import React, { useEffect, useState } from 'react';
import LeftArrow from '../../../../../../../asset/svg/leftArrow.svg';
import '../../../../../../../scss/pages/Attendance/Component/Asset/Assets/Agreement/DownloadAgreement/downloadAgreement.scss';
import { Document, Page, pdfjs } from 'react-pdf';
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;
import 'react-pdf/dist/Page/TextLayer.css';
import 'react-pdf/dist/Page/AnnotationLayer.css';



function DownloadAgreement(props) {
    const { setIsDownloadAgreement, viewPdf, viewPdfType, fileTypeView } = props;
    const [downloadData, setDownloadData] = useState()
    const handleBack = () => {
        setIsDownloadAgreement(false)
    }

    const navigatorShare = (pdfBase64) => {
        if (navigator.share) {
            const data = [new File([downloadData], 'Agreement.pdf', { type: "application/pdf" })]
            navigator.share({
                files: data,
            })
                .then(() => console.log("Shared successfully"))
                .catch(error => console.error("Not shared:", error))
        } else if (AssetManager) {
            AssetManager.shareFile(pdfBase64, 'Agreement');
        } else {
            console.log("Asset Manager not Found");
        }
        setIsDownloadAgreement(false)
    }

    const handleDownloadQR = async () => {
        if (downloadData) {
            // Download PDF
            const blob = new Blob([downloadData], { type: 'application/pdf' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'Agreement.pdf';
        }
        if (downloadData) {
            //Base64
            const pdfBlob = new Blob([downloadData], { type: 'application/pdf' });
            const pdfArrayBuffer = await new Response(pdfBlob).arrayBuffer();
            const pdfBase64 = btoa(new Uint8Array(pdfArrayBuffer).reduce((data, byte) => data + String.fromCharCode(byte), ''));
            navigatorShare(pdfBase64);
        }
    }

    const [numPages, setNumPages] = useState(1);

    const onDocumentLoadSuccess = (e) => {
        const { numPages } = e._pdfInfo;
        setNumPages(numPages)
    }
    const renderFile = (viewPdf, fileTypeView) => {
        if (fileTypeView == undefined) {
            return (
                <div className='Download-Agreement-Container_Parent_Document-image_Pdf-container'>
                    <Document loading={<p style={{ padding: "10px", color: "#000" }}>PDF file loading…</p>} noData={false} file={downloadData} onLoadSuccess={(e) => onDocumentLoadSuccess(e)} className='Download-Agreement-Container_Parent_Document-image_Pdf-container_doc'>
                        {Array.from(new Array(numPages), (el, index) => (
                            <Page key={`page_${index + 1}`} pageNumber={index + 1} />
                        ))}
                    </Document>
                </div>
            )
        } else {
            if (fileTypeView == "application/pdf") {
                return (
                    <div className='Download-Agreement-Container_Parent_Document-image_Pdf-container'>
                        <Document file={downloadData} onLoadSuccess={(e) => onDocumentLoadSuccess(e)} className='Download-Agreement-Container_Parent_Document-image_Pdf-container_doc'>
                            {Array.from(new Array(numPages), (el, index) => (
                                <Page key={`page_${index + 1}`} pageNumber={index + 1} />
                            ))}
                        </Document>
                    </div>
                )
            }
            else {
                return (
                    <div className='Download-Agreement-Container_Parent_Document-image_Pdf-container'>
                        <img src={viewPdf} alt="img" className='Download-Agreement-Container_Parent_Document-image' />
                    </div>)
            }
        }


    }
    useEffect(() => {
        fetch(viewPdf)
            .then(response => response.blob())
            .then(async (data) => setDownloadData(data))
    }, []);


    return (
        <div className='Download-Agreement-Container'>
            <div className='Download-Agreement-Container_header'>
                <div>
                    <img className='Download-Agreement-Container_header_image' src={LeftArrow} alt="" onClick={handleBack} />&nbsp;&nbsp;
                    <span className='Download-Agreement-Container_header_content'>{`${viewPdfType == 'Draft' ? 'Draft Agreement' : "Signed Agreement"}`}</span>
                </div>
            </div>
            <div className='Download-Agreement-Container_Parent'>
                <div className='Download-Agreement-Container_Parent_Document-image'>
                    {renderFile(viewPdf, fileTypeView)}
                </div>
            </div>
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", position: "relative" }}>
                <div className='Download-Agreement-Container_btn-bottom'>
                    <div className='Download-Agreement-Container_okbutton-container'>
                        <button className='Download-Agreement-Container_active-button' style={{ whiteSpace: "nowrap" }} id='handleDownload' onClick={handleDownloadQR}>Download</button>
                    </div>
                </div>
            </div>
        </div >
    )
}

export default DownloadAgreement